
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/odyssey/1/keymasters-pot",
      function () {
        return require("private-next-pages/odyssey/1/keymasters-pot/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/odyssey/1/keymasters-pot"])
      });
    }
  